import img1 from "../../assets/images/1.jpg";
import img2 from "../../assets/images/2.jpg";
import img3 from "../../assets/images/3.jpg";
import img4 from "../../assets/images/4.jpg";
import img5 from "../../assets/images/5.jpg";
import img6 from "../../assets/images/6.jpg";
import img7 from "../../assets/images/7.jpg";
import img8 from "../../assets/images/8.jpg";
import img9 from "../../assets/images/9.jpg";

const images = [
  {
    src: img1,
    height: 1336,
    width: 2000,
  },
  {
    src: img2,
    height: 1407,
    width: 2500,
  },
  {
    src: img3,
    height: 3500,
    width: 2338,
  },
  {
    src: img4,
    height: 1688,
    width: 3000,
  },
  {
    src: img5,
    height: 3000,
    width: 2004,
  },
  {
    src: img6,
    height: 3000,
    width: 2004,
  },
  {
    src: img7,
    height: 1407,
    width: 2500,
  },
  {
    src: img8,
    height: 1407,
    width: 2500,
  },
  {
    src: img9,
    height: 1407,
    width: 2500,
  },
];

export { images };
